/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { Controller } from "react-hook-form";

import { Checkbox } from "office-ui-fabric-react";

import { FlexCol, FlexRow } from "Components/Common/Layout/Layout";
import { HookErrorMessage } from "Components/ReactHookForm/HookErrorMessage/HookErrorMessage";

import { checkboxStyles } from "./CheckboxController.styles";
import { ICheckboxControllerProps } from "./ICheckboxControllerProps";

/**
 * CheckboxController.
 * @component
 * @param {ICheckboxControllerProps} props The component props.
 * @returns {React.ReactElement} CheckboxController.
 */
const CheckboxController: (props: ICheckboxControllerProps) => React.ReactElement = (
  props: ICheckboxControllerProps
): React.ReactElement => {
  const { inputName, labelDisplayName, control, isDisabled, errors } = props;
  return (
    <FlexCol>
      <FlexRow>
        <Controller
          name={inputName}
          control={control}
          render={({ field }): React.ReactElement => (
            <Checkbox
              {...props}
              aria-labelledby={labelDisplayName}
              label={labelDisplayName}
              styles={checkboxStyles}
              disabled={isDisabled}
              onChange={(e, checked) => field.onChange(checked)}
              checked={field.value}
            />
          )}
        />
      </FlexRow>
      <HookErrorMessage errors={errors} inputName={inputName} />
    </FlexCol>
  );
};

export default CheckboxController;
